import { announcementsQueries } from '~/services/queries'

export const useAnnouncements = () => {
  const state = useState('announcements', () => ({
    isLoading: false,
    items: [] as Record<string, unknown>[],
    item: {} as Record<string, unknown>,
  }))

  const items = computed(() => state.value.items)
  const item = computed(() => state.value.item)
  const isLoading = computed(() => state.value.isLoading)

  const fetchAnnouncementsForAdmin = async () => {
    useStoreFields().startSubmitting('admin/form')
    state.value.isLoading = true
    const { $gql } = useNuxtApp()
    const { result } = await $gql.request(announcementsQueries.announcementsForAdmin)
    state.value.items = result ?? []
    state.value.isLoading = false
    useStoreFields().finishSubmitting('admin/form')
  }

  const fetchAnnouncements = async () => {
    state.value.isLoading = true
    const { $gql } = useNuxtApp()
    const { result } = await $gql.request(announcementsQueries.announcements)
    state.value.items = result ?? []
    state.value.isLoading = false
  }

  const fetchAnnouncement = async (id: string | number) => {
    useStoreFields().startSubmitting('admin/form')
    state.value.isLoading = true
    const { $gql } = useNuxtApp()
    const { result } = await $gql.request(announcementsQueries.announcement, { id })
    state.value.item = result ?? {}
    state.value.isLoading = false
    useStoreFields().finishSubmitting('admin/form')
  }

  const announcementCreate = async ({ params, imageLeft, imageRight }) => {
    useStoreFields().startSubmitting('admin/form')
    state.value.isLoading = true
    const { $gql } = useNuxtApp()
    const { result } = await $gql.request(announcementsQueries.announcementCreate, {
      params,
      imageLeft,
      imageRight,
    })
    state.value.isLoading = false
    useStoreFields().finishSubmitting('admin/form')
    return result
  }

  const announcementUpdateImage = async ({ id, image, imagePosition }) => {
    state.value.isLoading = true
    const { $gql } = useNuxtApp()
    const { result } = await $gql.request(announcementsQueries.announcementUpdateImage, {
      id,
      image,
      imagePosition,
    })
    state.value.isLoading = false
    return result
  }

  const announcementUpdate = async ({ id, params }) => {
    useStoreFields().startSubmitting('admin/form')
    state.value.isLoading = true
    const { $gql } = useNuxtApp()
    const { result } = await $gql.request(announcementsQueries.announcementUpdate, {
      id,
      params,
    })
    state.value.isLoading = false
    useStoreFields().finishSubmitting('admin/form')
    return result
  }

  return {
    items,
    item,
    isLoading,
    fetchAnnouncements,
    fetchAnnouncementsForAdmin,
    fetchAnnouncement,
    announcementCreate,
    announcementUpdateImage,
    announcementUpdate,
  }
}
